// LandingPage.js
import React, { useEffect, useMemo, useState } from 'react';
import PROJECTS from '../data/projects';

const SUPPORTED_LANGUAGES = ['en', 'es', 'ru'];

const copy = {
    en: {
        languageLabel: 'Language',
        browseProjects: 'Browse projects',
        investCta: 'Invest from $200',
        safeCta: 'SAFE Terms',
        eyebrow: 'Product studio briefing',
        titleLine1: 'Denis Bystruev & Stas Shevchenko',
        titleLine2: 'build and ship AI products',
        subtitle: 'Human Rated AI is a two-founder studio with a portfolio spanning AI video, developer tools, marketplaces, and open-source infrastructure.',
        heroNote: 'Every project below is live on the internet or open source — explore the code, try the products, and back the builders behind them.',
        metrics: [
            { value: '306', label: 'projects tracked across the portfolio' },
            { value: '14', label: 'products live on the internet today' },
            { value: '292', label: 'open-source repositories on GitHub' },
            { value: '$200', label: 'Early Investor entry point' },
        ],
termsTitle: 'Invest in the builders',
        termsIntro: 'We are opening 100 Early Investor spots through a planned YC-style SAFE. You invest directly into the founders Denis Bystruev and Stas Shevchenko \u2014 a single position benefits from the success of any of the projects: Buddian, HuRated Movie Studio, Flaired, Supergenia, and everything we ship next.',
        termsCards: [
            { value: '100', title: 'Investor spots', text: 'Limited Early Investor plan for the first 100 participants.' },
            { value: '$200', title: '$200 per spot', text: 'Equivalent to 10,000 Telegram Stars in the current payment flow.' },
            { value: '$5M', title: '$5M Post-money cap', text: 'Planned SAFE valuation cap, subject to signed documents and eligibility.' },
        ],
        calculatorTitle: 'Ownership calculator',
        calculatorSpots: 'Spots',
        calculatorValuation: 'Future valuation',
        calculatorValuationHelp: '$5M+ means the cap applies, so higher valuations produce the same conversion percentage.',
        calculatorYourShare: 'Your estimated share',
        calculatorAllSpots: 'All 100 spots',
        calculatorConversionValuation: 'Conversion valuation',
        formulaText: 'At a $5M or higher future valuation, a $200 SAFE converts at the cap:',
        investorValueTitle: 'What early investors receive',
        investorValueCards: [
            {
                title: 'Portfolio-wide upside',
                text: 'Early investors benefit from the success of any project the founders ship, not a single bet.',
            },
            {
                title: 'Direct founder access',
                text: 'Follow usage, releases, and roadmap decisions directly from Denis and Stas as the portfolio evolves.',
            },
            {
                title: 'SAFE paperwork',
                text: 'Investment participation is completed through SAFE documentation, not just an app purchase.',
            },
        ],
        contactPrefix: 'Questions or SAFE paperwork:',
        founderRole1: 'Full-Stack AI Product Dev | Multimodal & Agentic Systems, ex. Apple / IBM / Intel',
        founderRole2: 'Co-Founder, Chief Business Officer (CBO), Product Developer',
        teamTitle: 'Team',
        projectsTitle: 'Projects & open source',
        projectsIntro: 'Live products and open-source repositories built across the HuRated ecosystem and related accounts, grouped by year of last update. Search filters every table; click a column header to sort an individual table.',
        projectsOlder: '2023 & before',
        projectsSearchLabel: 'Search projects',
        projectsSearchPlaceholder: 'Search by name or description…',
        projectsColName: 'Project',
        projectsColDescription: 'Description',
        projectsColSize: 'Size',
        projectsColUpdated: 'Updated',
        projectsColCreated: 'First commit',
        projectsSiteLink: 'Website',
        projectsShowing: (visible, total) => `Showing ${visible} of ${total} projects`,
        footerLinks: {
            pricing: 'Pricing',
            terms: 'Terms of Service',
            privacy: 'Privacy Policy',
            refund: 'Refund Policy',
        },
    },
    es: {
        languageLabel: 'Idioma',
        browseProjects: 'Ver proyectos',
        investCta: 'Invertir desde $200',
        safeCta: 'Términos SAFE',
        eyebrow: 'Resumen del estudio de productos',
        titleLine1: 'Denis Bystruev y Stas Shevchenko',
        titleLine2: 'crean y lanzan productos de IA',
        subtitle: 'Human Rated AI es un estudio de dos fundadores con un portafolio que abarca video con IA, herramientas para desarrolladores, marketplaces e infraestructura de código abierto.',
        heroNote: 'Cada proyecto está en producción o publicado como código abierto: explora el código, prueba los productos y apoya a los fundadores detrás de ellos.',
        metrics: [
            { value: '306', label: 'proyectos en el portafolio' },
            { value: '14', label: 'productos en línea hoy' },
            { value: '292', label: 'repositorios de código abierto en GitHub' },
            { value: '$200', label: 'entrada para primeros inversores' },
        ],
termsTitle: 'Invierte en los fundadores',
        termsIntro: 'Abrimos 100 plazas para primeros inversores mediante un SAFE planificado al estilo YC. Inviertes directamente en los fundadores Denis Bystruev y Stas Shevchenko: una sola posición se beneficia del éxito de cualquiera de los proyectos: Buddian, HuRated Movie Studio, Flaired, Supergenia y todo lo que lancemos después.',
        termsCards: [
            { value: '100', title: 'Plazas para inversores', text: 'Plan limitado para los primeros 100 participantes.' },
            { value: '$200', title: '$200 por plaza', text: 'Equivalente a 10,000 Telegram Stars en el flujo de pago actual.' },
            { value: '$5M', title: 'Límite de $5M posterior a la inversión', text: 'Límite de valoración SAFE planificado, sujeto a documentos firmados y elegibilidad.' },
        ],
        calculatorTitle: 'Calculadora de participación',
        calculatorSpots: 'Plazas',
        calculatorValuation: 'Valoración futura',
        calculatorValuationHelp: '$5M+ significa que aplica el límite; valoraciones más altas dan el mismo porcentaje de conversión.',
        calculatorYourShare: 'Participación estimada',
        calculatorAllSpots: 'Las 100 plazas',
        calculatorConversionValuation: 'Valoración de conversión',
        formulaText: 'Con una valoración futura de $5M o superior, un SAFE de $200 convierte al límite:',
        investorValueTitle: 'Qué reciben los primeros inversores',
        investorValueCards: [
            {
                title: 'Beneficio de todo el portafolio',
                text: 'Los primeros inversores se benefician del éxito de cualquier proyecto que lancen los fundadores, no de una sola apuesta.',
            },
            {
                title: 'Acceso directo a los fundadores',
                text: 'Sigue el uso, los lanzamientos y las decisiones de hoja de ruta directamente de Denis y Stas mientras evoluciona el portafolio.',
            },
            {
                title: 'Documentación SAFE',
                text: 'La participación de inversión se completa mediante documentación SAFE, no solo con una compra en la app.',
            },
        ],
        contactPrefix: 'Preguntas o documentación SAFE:',
        founderRole1: 'Desarrollo de producto de IA full-stack | Sistemas multimodales y agénticos, ex. Apple / IBM / Intel',
        founderRole2: 'Cofundador, Director de Negocio (CBO), Desarrollador de Producto',
        teamTitle: 'Equipo',
        projectsTitle: 'Proyectos y código abierto',
        projectsIntro: 'Productos en vivo y repositorios de código abierto del ecosistema HuRated y cuentas relacionadas, agrupados por año de última actualización. La búsqueda filtra todas las tablas; haz clic en un encabezado para ordenar cada tabla.',
        projectsOlder: '2023 y anteriores',
        projectsSearchLabel: 'Buscar proyectos',
        projectsSearchPlaceholder: 'Buscar por nombre o descripción…',
        projectsColName: 'Proyecto',
        projectsColDescription: 'Descripción',
        projectsColSize: 'Tamaño',
        projectsColUpdated: 'Actualizado',
        projectsColCreated: 'Primer commit',
        projectsSiteLink: 'Sitio web',
        projectsShowing: (visible, total) => `Mostrando ${visible} de ${total} proyectos`,
        footerLinks: {
            pricing: 'Precios',
            terms: 'Términos de servicio',
            privacy: 'Política de privacidad',
            refund: 'Política de reembolso',
        },
    },
    ru: {
        languageLabel: 'Язык',
        browseProjects: 'Смотреть проекты',
        investCta: 'Инвестировать от $200',
        safeCta: 'Условия SAFE',
        eyebrow: 'Брифинг продуктовой студии',
        titleLine1: 'Денис Быструев и Стас Шевченко',
        titleLine2: 'создают и запускают ИИ-продукты',
        subtitle: 'Human Rated AI — студия двух основателей с портфелем от ИИ-видео и инструментов для разработчиков до маркетплейсов и открытой инфраструктуры.',
        heroNote: 'Каждый проект работает в продакшене или опубликован как открытый код — изучайте код, пробуйте продукты и инвестируйте в основателей.',
        metrics: [
            { value: '306', label: 'проектов в портфеле' },
            { value: '14', label: 'продуктов работают онлайн' },
            { value: '292', label: 'open-source репозиториев на GitHub' },
            { value: '$200', label: 'вход для раннего инвестора' },
        ],
termsTitle: 'Инвестируйте в основателей',
        termsIntro: 'Мы открываем 100 мест ранних инвесторов через планируемый SAFE в стиле YC. Вы инвестируете напрямую в основателей Дениса Быструева и Стаса Шевченко — одна позиция даёт выгоду от успеха любого из проектов: Buddian, HuRated Movie Studio, Flaired, Supergenia и всего, что мы выпустим дальше.',
        termsCards: [
            { value: '100', title: 'Мест для инвесторов', text: 'Ограниченный план для первых 100 участников.' },
            { value: '$200', title: '$200 за место', text: 'Эквивалент 10,000 Telegram Stars в текущем платежном потоке.' },
            { value: '$5M', title: 'Лимит оценки $5M после инвестиций', text: 'Планируемый лимит оценки SAFE, при условии подписанных документов и соответствия требованиям.' },
        ],
        calculatorTitle: 'Калькулятор доли',
        calculatorSpots: 'Места',
        calculatorValuation: 'Будущая оценка',
        calculatorValuationHelp: '$5M+ означает, что применяется лимит; более высокие оценки дают тот же процент конвертации.',
        calculatorYourShare: 'Оценочная доля',
        calculatorAllSpots: 'Все 100 мест',
        calculatorConversionValuation: 'Оценка конвертации',
        formulaText: 'При будущей оценке $5M или выше SAFE на $200 конвертируется по лимиту:',
        investorValueTitle: 'Что получают ранние инвесторы',
        investorValueCards: [
            {
                title: 'Рост всего портфеля',
                text: 'Ранние инвесторы получают выгоду от успеха любого проекта основателей, а не одной ставки.',
            },
            {
                title: 'Прямой доступ к основателям',
                text: 'Следите за использованием, релизами и решениями по развитию портфеля напрямую от Дениса и Стаса.',
            },
            {
                title: 'SAFE документы',
                text: 'Участие в инвестиции завершается через SAFE-документацию, а не только покупкой в приложении.',
            },
        ],
        contactPrefix: 'Вопросы или SAFE-документы:',
        founderRole1: 'Разработка ИИ-продуктов full-stack | Мультимодальные и агентные системы, экс. Apple / IBM / Intel',
        founderRole2: 'Сооснователь, коммерческий директор (CBO), разработчик продукта',
        teamTitle: 'Команда',
        projectsTitle: 'Проекты и открытый код',
        projectsIntro: 'Работающие продукты и open-source репозитории экосистемы HuRated и связанных аккаунтов, сгруппированные по году последнего обновления. Поиск фильтрует все таблицы; нажмите на заголовок столбца, чтобы отсортировать конкретную таблицу.',
        projectsOlder: '2023 и ранее',
        projectsSearchLabel: 'Поиск проектов',
        projectsSearchPlaceholder: 'Поиск по названию или описанию…',
        projectsColName: 'Проект',
        projectsColDescription: 'Описание',
        projectsColSize: 'Размер',
        projectsColUpdated: 'Обновлён',
        projectsColCreated: 'Первый коммит',
        projectsSiteLink: 'Сайт',
        projectsShowing: (visible, total) => `Показано ${visible} из ${total} проектов`,
        footerLinks: {
            pricing: 'Цены',
            terms: 'Условия сервиса',
            privacy: 'Политика конфиденциальности',
            refund: 'Политика возврата',
        },
    },
};

const getInitialLanguage = () => {
    if (typeof window === 'undefined') {
        return 'en';
    }

    const params = new URLSearchParams(window.location.search);
    const lang = params.get('lang');
    return SUPPORTED_LANGUAGES.includes(lang) ? lang : 'en';
};

const replaceLanguageInUrl = (lang) => {
    if (typeof window === 'undefined') {
        return;
    }

    const url = new URL(window.location.href);
    url.searchParams.set('lang', lang);
    window.history.replaceState(window.history.state, '', `${url.pathname}${url.search}${url.hash}`);
};

const clampNumber = (value, min, max) => {
    const numeric = Number(value);
    if (!Number.isFinite(numeric)) {
        return min;
    }

    return Math.max(min, Math.min(max, numeric));
};

const formatValuationLabel = (millions) => {
    const value = Number(millions || 5);
    if (value >= 5) {
        return '$5M+';
    }

    return `$${value.toFixed(value % 1 === 0 ? 0 : 2).replace(/0+$/, '').replace(/\.$/, '')}M`;
};

const formatInvestPercent = (value) => {
    const numeric = Number(value || 0);
    if (numeric >= 0.01) {
        return `${numeric.toFixed(3).replace(/0+$/, '').replace(/\.$/, '')}%`;
    }

    return `${numeric.toFixed(4).replace(/0+$/, '').replace(/\.$/, '')}%`;
};

const formatProjectSize = (sizeKB) => {
    if (!Number.isFinite(sizeKB) || sizeKB === null) {
        return '—';
    }

    if (sizeKB >= 1024) {
        return `${(sizeKB / 1024).toFixed(sizeKB >= 10240 ? 0 : 1)} MB`;
    }

    return `${sizeKB} KB`;
};

const projectDescription = (project, language) => {
    if (language === 'es' && project.descEs) {
        return project.descEs;
    }

    if (language === 'ru' && project.descRu) {
        return project.descRu;
    }

    return project.desc || '—';
};

const ProjectNameLink = ({ project, style }) => {
    const href = project.site || project.gh;

    if (!href) {
        return <span style={style}>{project.name}</span>;
    }

    return (
        <a href={href} target="_blank" rel="noopener noreferrer" style={{ ...style, color: 'inherit', textDecoration: 'none' }}>
            {project.name}
        </a>
    );
};

const PROJECT_YEAR_GROUPS = [
    { id: '2026', years: ['2026', ''] },
    { id: '2025', years: ['2025'] },
    { id: '2024', years: ['2024'] },
];

const projectYearGroup = (project) => {
    const year = (project.updated || '').slice(0, 4);
    const group = PROJECT_YEAR_GROUPS.find((entry) => entry.years.includes(year));
    return group ? group.id : 'older';
};

const compareProjects = (a, b, key) => {
    let result = 0;
    if (key === 'name') {
        result = a.name.toLowerCase().localeCompare(b.name.toLowerCase());
    } else if (key === 'created') {
        result = (a.created || '').localeCompare(b.created || '');
    } else if (key === 'size') {
        result = (a.sizeKB || 0) - (b.sizeKB || 0);
    } else {
        result = (a.updated || '').localeCompare(b.updated || '');
    }

    if (result === 0) {
        result = a.name.toLowerCase().localeCompare(b.name.toLowerCase());
    }

    return result;
};

const ProjectsTable = ({ t, colors, isDarkMode, language }) => {
    const [query, setQuery] = useState('');
    const [sortState, setSortState] = useState({});

    const filtered = useMemo(() => {
        const needle = query.trim().toLowerCase();
        return PROJECTS.filter((project) => (
            !needle
            || project.name.toLowerCase().includes(needle)
            || project.desc.toLowerCase().includes(needle)
        ));
    }, [query]);

    const groups = [
        { id: '2026', label: '2026', rows: [] },
        { id: '2025', label: '2025', rows: [] },
        { id: '2024', label: '2024', rows: [] },
        { id: 'older', label: t.projectsOlder, rows: [] },
    ];

    for (const project of filtered) {
        const groupId = projectYearGroup(project);
        const group = groups.find((entry) => entry.id === groupId);
        group.rows.push(project);
    }

    for (const group of groups) {
        const sort = sortState[group.id] || { key: 'updated', dir: 'desc' };
        const direction = sort.dir === 'asc' ? 1 : -1;
        group.rows.sort((a, b) => compareProjects(a, b, sort.key) * direction);
    }

    const getSort = (groupId) => sortState[groupId] || { key: 'updated', dir: 'desc' };

    const handleSortClick = (groupId, key) => {
        setSortState((prev) => {
            const current = prev[groupId] || { key: 'updated', dir: 'desc' };
            const next = current.key === key
                ? { key, dir: current.dir === 'asc' ? 'desc' : 'asc' }
                : { key, dir: key === 'name' ? 'asc' : 'desc' };
            return { ...prev, [groupId]: next };
        });
    };

    const styles = {
        controls: {
            display: 'flex',
            flexWrap: 'wrap',
            alignItems: 'center',
            justifyContent: 'space-between',
            gap: '10px',
            margin: '18px 0 12px',
        },
        search: {
            flex: '1 1 260px',
            maxWidth: '420px',
            minHeight: '42px',
            padding: '9px 12px',
            borderRadius: '6px',
            border: `1px solid ${colors.border}`,
            backgroundColor: isDarkMode ? '#0b1118' : '#ffffff',
            color: colors.text,
            fontSize: '14px',
            fontFamily: 'inherit',
            boxSizing: 'border-box',
        },
        count: {
            color: colors.muted,
            fontSize: '13px',
        },
        groupHeader: {
            margin: '22px 0 8px',
            fontSize: '18px',
        },
        groupHeaderCount: {
            color: colors.muted,
            fontWeight: 'normal',
            fontSize: '14px',
        },
        tableWrap: {
            overflowX: 'auto',
            border: `1px solid ${colors.border}`,
            borderRadius: '8px',
            backgroundColor: colors.surface,
        },
        table: {
            width: '100%',
            borderCollapse: 'collapse',
            fontSize: '13px',
            minWidth: '640px',
        },
        th: {
            textAlign: 'left',
            padding: '10px 12px',
            borderBottom: `1px solid ${colors.border}`,
            whiteSpace: 'nowrap',
            color: colors.muted,
            fontWeight: '800',
            fontSize: '12px',
            textTransform: 'uppercase',
            letterSpacing: 0,
            verticalAlign: 'top',
        },
        thButton: {
            background: 'none',
            border: 'none',
            padding: 0,
            font: 'inherit',
            color: 'inherit',
            cursor: 'pointer',
            textTransform: 'inherit',
            letterSpacing: 'inherit',
            display: 'block',
        },
        thButtonActive: {
            color: colors.accentDark,
        },
        td: {
            padding: '10px 12px',
            borderBottom: `1px solid ${colors.border}`,
            verticalAlign: 'top',
            lineHeight: 1.5,
        },
        name: {
            fontWeight: '800',
            overflowWrap: 'break-word',
        },
        owner: {
            display: 'block',
            marginTop: '2px',
            color: colors.muted,
            fontSize: '11px',
            fontWeight: 'normal',
        },
        description: {
            margin: 0,
            color: colors.muted,
            minWidth: '220px',
        },
        link: {
            color: colors.link,
            textDecoration: 'none',
            whiteSpace: 'nowrap',
        },
        dateCell: {
            whiteSpace: 'nowrap',
        },
        datePrimary: {
            display: 'block',
        },
        dateSecondary: {
            display: 'block',
            marginTop: '2px',
            color: colors.muted,
            fontSize: '12px',
        },
        mutedCell: {
            color: colors.muted,
            whiteSpace: 'nowrap',
        },
    };

    const sortArrow = (groupId, key) => {
        const sort = getSort(groupId);
        if (sort.key !== key) {
            return '↕';
        }

        return sort.dir === 'asc' ? '↑' : '↓';
    };

    const sortableTh = (groupId, key, label) => {
        const sort = getSort(groupId);
        const active = sort.key === key;
        return (
            <th
                style={styles.th}
                aria-sort={active ? (sort.dir === 'asc' ? 'ascending' : 'descending') : 'none'}
            >
                <button
                    type="button"
                    style={{ ...styles.thButton, ...(active ? styles.thButtonActive : {}) }}
                    onClick={() => handleSortClick(groupId, key)}
                >
                    {label} {sortArrow(groupId, key)}
                </button>
            </th>
        );
    };

    const visibleGroups = groups.filter((group) => group.rows.length > 0);

    return (
        <div>
            <div style={styles.controls}>
                <input
                    type="search"
                    value={query}
                    onChange={(event) => setQuery(event.target.value)}
                    placeholder={t.projectsSearchPlaceholder}
                    aria-label={t.projectsSearchLabel}
                    style={styles.search}
                />
                <span style={styles.count}>{t.projectsShowing(filtered.length, PROJECTS.length)}</span>
            </div>

            {visibleGroups.map((group) => (
                <div key={group.id}>
                    <h3 style={styles.groupHeader}>
                        {group.label}{' '}
                        <span style={styles.groupHeaderCount}>· {group.rows.length}</span>
                    </h3>
                    <div style={styles.tableWrap}>
                        <table style={styles.table}>
                            <thead>
                                <tr>
                                    {sortableTh(group.id, 'name', t.projectsColName)}
                                    <th style={styles.th}>{t.projectsColDescription}</th>
                                    {sortableTh(group.id, 'size', t.projectsColSize)}
                                    <th style={{ ...styles.th }} aria-sort={getSort(group.id).key === 'updated' || getSort(group.id).key === 'created' ? (getSort(group.id).dir === 'asc' ? 'ascending' : 'descending') : 'none'}>
                                        <button
                                            type="button"
                                            style={{
                                                ...styles.thButton,
                                                ...(getSort(group.id).key === 'updated' ? styles.thButtonActive : {}),
                                            }}
                                            onClick={() => handleSortClick(group.id, 'updated')}
                                        >
                                            {t.projectsColUpdated} {sortArrow(group.id, 'updated')}
                                        </button>
                                        <button
                                            type="button"
                                            style={{
                                                ...styles.thButton,
                                                ...(getSort(group.id).key === 'created' ? styles.thButtonActive : {}),
                                            }}
                                            onClick={() => handleSortClick(group.id, 'created')}
                                        >
                                            {t.projectsColCreated} {sortArrow(group.id, 'created')}
                                        </button>
                                    </th>
                                </tr>
                            </thead>
                            <tbody>
                                {group.rows.map((project) => (
                                    <tr key={`${project.owner || 'site'}-${project.name}`}>
                                        <td style={styles.td}>
                                            <ProjectNameLink project={project} style={styles.name} />
                                            {project.owner ? (
                                                <span style={styles.owner}>{project.owner}</span>
                                            ) : null}
                                        </td>
                                        <td style={styles.td}>
                                            <p style={styles.description}>
                                                {projectDescription(project, language)}
                                                {project.site && project.gh ? (
                                                    <>
                                                        {' '}
                                                        <a href={project.gh} target="_blank" rel="noopener noreferrer" style={styles.link}>
                                                            GitHub
                                                        </a>
                                                    </>
                                                ) : null}
                                            </p>
                                        </td>
                                        <td style={{ ...styles.td, ...styles.mutedCell }}>{formatProjectSize(project.sizeKB)}</td>
                                        <td style={{ ...styles.td }}>
                                            <span style={styles.datePrimary}>{project.updated || '—'}</span>
                                            <span style={styles.dateSecondary}>{project.created || '—'}</span>
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                </div>
            ))}

            {visibleGroups.length === 0 ? (
                <p style={styles.count}>—</p>
            ) : null}
        </div>
    );
};

const LandingPage = ({ isDarkMode }) => {
    const [language, setLanguage] = useState(getInitialLanguage);
    const [calculatorSpots, setCalculatorSpots] = useState(1);
    const [valuationMillions, setValuationMillions] = useState(5);
    const [windowWidth, setWindowWidth] = useState(typeof window === 'undefined' ? 1200 : window.innerWidth);
    const t = copy[language];
    const normalizedSpots = Math.floor(clampNumber(calculatorSpots, 1, 100));
    const normalizedValuation = clampNumber(valuationMillions, 1, 5);
    const conversionValuation = Math.min(5000000, Math.max(1000000, normalizedValuation * 1000000));
    const estimatedShare = ((normalizedSpots * 200) / conversionValuation) * 100;
    const allSpotsShare = ((100 * 200) / conversionValuation) * 100;
    const valuationLabel = formatValuationLabel(normalizedValuation);
    // Metric boxes: 4 in a row on wide screens, 2x2 on medium, single column
    // on narrow — never an uneven 3+1 layout.
    const metricColumns = windowWidth >= 950 ? 4 : windowWidth >= 500 ? 2 : 1;

    useEffect(() => {
        replaceLanguageInUrl(getInitialLanguage());

        const handlePopState = () => {
            setLanguage(getInitialLanguage());
        };

        window.addEventListener('popstate', handlePopState);

        return () => {
            window.removeEventListener('popstate', handlePopState);
        };
    }, []);

    useEffect(() => {
        const handleResize = () => {
            setWindowWidth(window.innerWidth);
        };

        window.addEventListener('resize', handleResize);

        return () => {
            window.removeEventListener('resize', handleResize);
        };
    }, []);

    const handleCalculatorSpotsChange = (event) => {
        setCalculatorSpots(Math.floor(clampNumber(event.target.value, 1, 100)));
    };

    const handleValuationChange = (event) => {
        setValuationMillions(clampNumber(event.target.value, 1, 5));
    };

    const handleLanguageClick = (nextLanguage) => {
        if (!SUPPORTED_LANGUAGES.includes(nextLanguage)) {
            return;
        }

        setLanguage(nextLanguage);
        replaceLanguageInUrl(nextLanguage);
    };

    const openExternal = (url) => {
        window.open(url, '_blank', 'noopener,noreferrer');
    };

    const handleEmailClick = () => {
        window.open('mailto:den@hurated.com');
    };

    const handleInvestClick = () => {
        window.location.href = `/invest?lang=${language}`;
    };

    const handleSafeClick = () => {
        window.location.href = `/invest?lang=${language}#safe`;
    };

    const handleLinkedInClick = (url) => {
        openExternal(url);
    };

    const colors = {
        page: isDarkMode ? '#070b10' : '#f5f7fb',
        topBar: isDarkMode ? '#05070a' : '#ffffff',
        surface: isDarkMode ? '#101720' : '#ffffff',
        raised: isDarkMode ? '#15202b' : '#edf2f7',
        text: isDarkMode ? '#f7fafc' : '#111827',
        muted: isDarkMode ? '#c3cad5' : '#536071',
        border: isDarkMode ? '#263447' : '#dce3eb',
        accent: '#0e9f6e',
        accentDark: '#087f5b',
        amber: '#b7791f',
        coral: '#c2410c',
        link: isDarkMode ? '#8ddbc1' : '#087f5b',
    };

    const styles = {
        page: {
            minHeight: '100vh',
            backgroundColor: colors.page,
            color: colors.text,
            fontFamily: 'Arial, sans-serif',
        },
        topNav: {
            position: 'sticky',
            top: 0,
            zIndex: 3,
            backgroundColor: colors.topBar,
            borderBottom: `1px solid ${colors.border}`,
        },
        topNavInner: {
            width: '100%',
            maxWidth: '1120px',
            margin: '0 auto',
            padding: '10px 16px',
            boxSizing: 'border-box',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            gap: '8px',
        },
        topLogo: {
            display: 'block',
            width: '108px',
            height: 'auto',
            flexShrink: 0,
        },
        languageButton: {
            minWidth: '48px',
            minHeight: '38px',
            padding: '8px 12px',
            borderRadius: '6px',
            border: `1px solid ${colors.border}`,
            backgroundColor: colors.surface,
            color: colors.text,
            cursor: 'pointer',
            fontSize: '13px',
            fontWeight: '700',
            letterSpacing: 0,
            flexShrink: 0,
        },
        languageButtonActive: {
            backgroundColor: colors.accent,
            borderColor: colors.accent,
            color: '#ffffff',
        },
        container: {
            width: '100%',
            maxWidth: '1120px',
            margin: '0 auto',
            padding: '22px 16px 48px',
            boxSizing: 'border-box',
        },
        hero: {
            padding: '26px 0 24px',
            textAlign: 'left',
        },
        eyebrow: {
            margin: '0 0 10px',
            color: colors.accentDark,
            fontSize: '13px',
            fontWeight: '800',
            letterSpacing: 0,
            textTransform: 'uppercase',
        },
        title: {
            margin: '0',
            maxWidth: '920px',
            fontSize: '34px',
            lineHeight: 1.08,
            letterSpacing: 0,
            overflowWrap: 'break-word',
        },
        subtitle: {
            margin: '18px 0 0',
            maxWidth: '820px',
            fontSize: '18px',
            lineHeight: 1.5,
            color: colors.muted,
            fontWeight: 'normal',
        },
        heroNote: {
            margin: '16px 0 0',
            maxWidth: '760px',
            fontSize: '15px',
            lineHeight: 1.6,
            color: colors.muted,
        },
        buttonRow: {
            display: 'flex',
            flexWrap: 'wrap',
            justifyContent: 'center',
            alignItems: 'stretch',
            gap: '10px',
            margin: '24px auto 0',
            maxWidth: '760px',
        },
        button: {
            width: 'auto',
            maxWidth: '100%',
            minWidth: '132px',
            minHeight: '48px',
            padding: '13px 16px',
            border: 'none',
            borderRadius: '6px',
            cursor: 'pointer',
            fontWeight: '800',
            fontSize: '15px',
            textAlign: 'center',
            whiteSpace: 'nowrap',
        },
        primaryButton: {
            backgroundColor: colors.accent,
            color: '#ffffff',
        },
        secondaryButton: {
            backgroundColor: colors.coral,
            color: '#ffffff',
        },
        safeButton: {
            backgroundColor: isDarkMode ? '#273244' : '#111827',
            color: '#ffffff',
        },
        metricGrid: {
            display: 'grid',
            gridTemplateColumns: `repeat(${metricColumns}, 1fr)`,
            gap: '12px',
            margin: '24px 0 0',
        },
        metric: {
            padding: '16px',
            backgroundColor: colors.surface,
            border: `1px solid ${colors.border}`,
            borderRadius: '8px',
        },
        metricValue: {
            display: 'block',
            marginBottom: '6px',
            color: colors.accentDark,
            fontSize: '28px',
            lineHeight: 1,
            fontWeight: '800',
        },
        metricLabel: {
            margin: 0,
            color: colors.muted,
            fontSize: '14px',
            lineHeight: 1.45,
        },
        section: {
            padding: '30px 0',
            borderTop: `1px solid ${colors.border}`,
        },
        sectionHeader: {
            margin: '0 0 10px',
            fontSize: '26px',
            lineHeight: 1.15,
            letterSpacing: 0,
        },
        sectionIntro: {
            margin: '0 0 18px',
            maxWidth: '760px',
            color: colors.muted,
            fontSize: '16px',
            lineHeight: 1.6,
        },
        cardTitle: {
            margin: '0 0 10px',
            fontSize: '20px',
            lineHeight: 1.25,
        },
        bodyText: {
            margin: '0 0 12px',
            color: colors.muted,
            fontSize: '15px',
            lineHeight: 1.6,
        },
        cardGrid: {
            display: 'grid',
            gridTemplateColumns: 'repeat(auto-fit, minmax(230px, 1fr))',
            gap: '14px',
            marginTop: '18px',
        },
        card: {
            padding: '18px',
            backgroundColor: colors.surface,
            border: `1px solid ${colors.border}`,
            borderRadius: '8px',
        },
        termCard: {
            padding: '18px',
            backgroundColor: colors.surface,
            border: `1px solid ${colors.border}`,
            borderRadius: '8px',
            textAlign: 'left',
        },
        formula: {
            display: 'inline-block',
            marginTop: '6px',
            padding: '10px 12px',
            backgroundColor: colors.raised,
            border: `1px solid ${colors.border}`,
            borderRadius: '6px',
            color: colors.text,
            fontWeight: '800',
            overflowWrap: 'break-word',
        },
        formulaLine: {
            display: 'flex',
            flexWrap: 'wrap',
            alignItems: 'center',
            gap: '8px',
            margin: '0',
            color: colors.muted,
            fontSize: '15px',
            lineHeight: 1.6,
        },
        calculator: {
            display: 'grid',
            gap: '14px',
            marginTop: '18px',
            padding: '18px',
            backgroundColor: colors.surface,
            border: `1px solid ${colors.border}`,
            borderRadius: '8px',
        },
        calculatorControls: {
            display: 'grid',
            gridTemplateColumns: 'repeat(auto-fit, minmax(210px, 1fr))',
            gap: '12px',
        },
        calculatorLabel: {
            display: 'grid',
            gap: '7px',
            color: colors.muted,
            fontSize: '13px',
            fontWeight: '800',
            textTransform: 'uppercase',
        },
        calculatorInput: {
            width: '100%',
            minHeight: '42px',
            boxSizing: 'border-box',
            padding: '9px 10px',
            borderRadius: '6px',
            border: `1px solid ${colors.border}`,
            backgroundColor: isDarkMode ? '#0b1118' : '#ffffff',
            color: colors.text,
            fontSize: '16px',
            fontWeight: '700',
        },
        sliderRow: {
            display: 'grid',
            gridTemplateColumns: 'auto minmax(0, 1fr) auto',
            alignItems: 'center',
            gap: '10px',
            color: colors.muted,
            fontSize: '13px',
            fontWeight: '800',
        },
        slider: {
            width: '100%',
            minHeight: '34px',
            padding: 0,
            accentColor: colors.accent,
        },
        calculatorResultGrid: {
            display: 'grid',
            gridTemplateColumns: 'repeat(auto-fit, minmax(150px, 1fr))',
            gap: '10px',
        },
        calculatorResult: {
            minWidth: 0,
            padding: '14px',
            border: `1px solid ${colors.border}`,
            borderRadius: '8px',
            backgroundColor: colors.raised,
        },
        calculatorResultLabel: {
            display: 'block',
            marginBottom: '6px',
            color: colors.muted,
            fontSize: '12px',
            fontWeight: '800',
            textTransform: 'uppercase',
        },
        calculatorResultValue: {
            display: 'block',
            color: colors.text,
            fontSize: '21px',
            fontWeight: '800',
            overflowWrap: 'anywhere',
        },
        calculatorHelp: {
            margin: 0,
            color: colors.muted,
            fontSize: '13px',
            lineHeight: 1.5,
        },
        contact: {
            margin: '22px 0 0',
            fontSize: '15px',
            lineHeight: 1.6,
            color: colors.muted,
        },
        span: {
            cursor: 'pointer',
            textDecoration: 'underline',
            color: colors.link,
            fontWeight: '700',
        },
        teamContainer: {
            display: 'grid',
            gridTemplateColumns: 'repeat(auto-fit, minmax(250px, 1fr))',
            gap: '14px',
            marginTop: '18px',
        },
        teamMember: {
            padding: '15px',
            backgroundColor: colors.surface,
            borderRadius: '8px',
            fontSize: '14px',
            lineHeight: '1.5',
            color: colors.text,
            border: `1px solid ${colors.border}`,
        },
        teamProfile: {
            display: 'flex',
            alignItems: 'center',
            gap: '14px',
            textAlign: 'left',
        },
        teamPhoto: {
            width: '60px',
            height: '60px',
            borderRadius: '50%',
            objectFit: 'cover',
            border: `2px solid ${colors.accent}`,
            flexShrink: 0,
        },
        teamInfo: {
            flex: '1',
            minWidth: 0,
        },
        teamName: {
            cursor: 'pointer',
            color: colors.link,
            textDecoration: 'none',
        },
        footer: {
            marginTop: '20px',
            padding: '26px 0 6px',
            borderTop: `1px solid ${colors.border}`,
            textAlign: 'center',
        },
        footerLinks: {
            display: 'grid',
            gridTemplateColumns: 'repeat(auto-fit, minmax(136px, 1fr))',
            gap: '10px',
            maxWidth: '680px',
            margin: '0 auto',
        },
        footerLink: {
            color: colors.link,
            textDecoration: 'none',
            padding: '10px 12px',
            border: `1px solid ${colors.border}`,
            borderRadius: '6px',
            fontSize: '14px',
            fontWeight: '700',
        },
        footerCopyright: {
            marginTop: '18px',
            fontSize: '14px',
            color: colors.muted,
        },
    };

    return (
        <div style={styles.page}>
            <header style={styles.topNav}>
                <div style={styles.topNavInner}>
                    <img
                        src={`${process.env.PUBLIC_URL}/images/hrai_logo_1024.webp`}
                        alt="Human Rated AI Logo"
                        style={styles.topLogo}
                    />
                    <div aria-label={t.languageLabel}>
                        {SUPPORTED_LANGUAGES.map((lang) => (
                            <button
                                key={lang}
                                type="button"
                                aria-pressed={language === lang}
                                onClick={() => handleLanguageClick(lang)}
                                style={{
                                    ...styles.languageButton,
                                    ...(language === lang ? styles.languageButtonActive : {}),
                                    marginLeft: lang === SUPPORTED_LANGUAGES[0] ? 0 : '8px',
                                }}
                            >
                                {lang}
                            </button>
                        ))}
                    </div>
                </div>
            </header>

            <main style={styles.container}>
                <section style={styles.hero}>
                    <p style={styles.eyebrow}>{t.eyebrow}</p>
                    <h1 style={styles.title}>
                        <span style={{ display: 'block' }}>{t.titleLine1}</span>
                        <span style={{ display: 'block' }}>{t.titleLine2}</span>
                    </h1>
                    <h2 style={styles.subtitle}>{t.subtitle}</h2>
                    <p style={styles.heroNote}>{t.heroNote}</p>

                    <div style={styles.buttonRow}>
                        <a href="#projects" style={{ ...styles.button, ...styles.primaryButton, textDecoration: 'none', display: 'inline-flex', alignItems: 'center', justifyContent: 'center' }}>
                            {t.browseProjects}
                        </a>
                        <button type="button" onClick={handleInvestClick} style={{ ...styles.button, ...styles.secondaryButton }}>
                            {t.investCta}
                        </button>
                        <button type="button" onClick={handleSafeClick} style={{ ...styles.button, ...styles.safeButton }}>
                            {t.safeCta}
                        </button>
                    </div>

                    <div style={styles.metricGrid}>
                        {t.metrics.map((metric) => (
                            <div key={metric.value} style={styles.metric}>
                                <span style={styles.metricValue}>{metric.value}</span>
                                <p style={styles.metricLabel}>{metric.label}</p>
                            </div>
                        ))}
                    </div>
                </section>

                <section id="projects" style={styles.section}>
                    <h2 style={styles.sectionHeader}>{t.projectsTitle}</h2>
                    <p style={styles.sectionIntro}>{t.projectsIntro}</p>
                    <ProjectsTable t={t} colors={colors} isDarkMode={isDarkMode} language={language} />
                </section>

                <section style={styles.section}>
                    <h2 style={styles.sectionHeader}>{t.termsTitle}</h2>
                    <p style={styles.sectionIntro}>{t.termsIntro}</p>

                    <div style={styles.cardGrid}>
                        {t.termsCards.map((card) => (
                            <article key={card.title} style={styles.termCard}>
                                <span style={styles.metricValue}>{card.value}</span>
                                <h3 style={styles.cardTitle}>{card.title}</h3>
                                <p style={styles.bodyText}>{card.text}</p>
                            </article>
                        ))}
                    </div>

                    <div style={styles.calculator}>
                        <h3 style={styles.cardTitle}>{t.calculatorTitle}</h3>
                        <div style={styles.calculatorControls}>
                            <label style={styles.calculatorLabel}>
                                {t.calculatorSpots}
                                <input
                                    type="number"
                                    min="1"
                                    max="100"
                                    value={normalizedSpots}
                                    onChange={handleCalculatorSpotsChange}
                                    inputMode="numeric"
                                    style={styles.calculatorInput}
                                />
                            </label>
                            <label style={styles.calculatorLabel}>
                                {t.calculatorValuation}
                                <input
                                    type="number"
                                    min="1"
                                    max="5"
                                    step="0.25"
                                    value={normalizedValuation}
                                    onChange={handleValuationChange}
                                    inputMode="decimal"
                                    style={styles.calculatorInput}
                                />
                            </label>
                        </div>

                        <div style={styles.sliderRow}>
                            <span>$1M</span>
                            <input
                                type="range"
                                min="1"
                                max="5"
                                step="0.25"
                                value={normalizedValuation}
                                onChange={handleValuationChange}
                                style={styles.slider}
                            />
                            <strong>{valuationLabel}</strong>
                        </div>

                        <p style={styles.formulaLine}>
                            <span>{t.formulaText}</span>
                            <span style={styles.formula}>$200 / $5,000,000 = 0.004%</span>
                        </p>

                        <div style={styles.calculatorResultGrid}>
                            <div style={styles.calculatorResult}>
                                <span style={styles.calculatorResultLabel}>{t.calculatorYourShare}</span>
                                <strong style={styles.calculatorResultValue}>{formatInvestPercent(estimatedShare)}</strong>
                            </div>
                            <div style={styles.calculatorResult}>
                                <span style={styles.calculatorResultLabel}>{t.calculatorAllSpots}</span>
                                <strong style={styles.calculatorResultValue}>{formatInvestPercent(allSpotsShare)}</strong>
                            </div>
                            <div style={styles.calculatorResult}>
                                <span style={styles.calculatorResultLabel}>{t.calculatorConversionValuation}</span>
                                <strong style={styles.calculatorResultValue}>{valuationLabel}</strong>
                            </div>
                        </div>

                        <p style={styles.calculatorHelp}>{t.calculatorValuationHelp}</p>
                    </div>
                </section>

                <section style={styles.section}>
                    <h2 style={styles.sectionHeader}>{t.investorValueTitle}</h2>
                    <div style={styles.cardGrid}>
                        {t.investorValueCards.map((card) => (
                            <article key={card.title} style={styles.card}>
                                <h3 style={styles.cardTitle}>{card.title}</h3>
                                <p style={styles.bodyText}>{card.text}</p>
                            </article>
                        ))}
                    </div>

                    <p style={styles.contact}>
                        {t.contactPrefix}{' '}
                        <span style={styles.span} onClick={handleEmailClick} aria-label="Contact Email">
                            den@hurated.com
                        </span>
                    </p>
                </section>

                <section style={styles.section}>
                    <h2 style={styles.sectionHeader}>{t.teamTitle}</h2>
                    <div style={styles.teamContainer}>
                        <div style={styles.teamMember}>
                            <div style={styles.teamProfile}>
                                <img
                                    src={`${process.env.PUBLIC_URL}/images/team/bystruev.jpg`}
                                    alt="Denis Bystruev"
                                    style={styles.teamPhoto}
                                />
                                <div style={styles.teamInfo}>
                                    <strong
                                        style={styles.teamName}
                                        onClick={() => handleLinkedInClick('https://www.linkedin.com/in/denisbystruev/')}
                                    >
                                        Denis Bystruev
                                    </strong><br />
                                    {t.founderRole1}<br />
                                    San José, Costa Rica
                                </div>
                            </div>
                        </div>
                        <div style={styles.teamMember}>
                            <div style={styles.teamProfile}>
                                <img
                                    src={`${process.env.PUBLIC_URL}/images/team/shevchenko.jpg`}
                                    alt="Stas Shevchenko"
                                    style={styles.teamPhoto}
                                />
                                <div style={styles.teamInfo}>
                                    <strong
                                        style={styles.teamName}
                                        onClick={() => handleLinkedInClick('https://www.linkedin.com/in/stanislav-shevchenko-7714664b/')}
                                    >
                                        Stas Shevchenko
                                    </strong><br />
                                    {t.founderRole2}<br />
                                    Andalusia, Spain
                                </div>
                            </div>
                        </div>
                    </div>
                </section>



                <footer style={styles.footer}>
                    <div style={styles.footerLinks}>
                        <a href="/pricing" style={styles.footerLink}>{t.footerLinks.pricing}</a>
                        <a href="/terms" style={styles.footerLink}>{t.footerLinks.terms}</a>
                        <a href="/privacy" style={styles.footerLink}>{t.footerLinks.privacy}</a>
                        <a href="/refund" style={styles.footerLink}>{t.footerLinks.refund}</a>
                    </div>
                    <div style={styles.footerCopyright}>
                        &copy; 2026 Human Rated AI. All rights reserved.
                    </div>
                </footer>
            </main>
        </div>
    );
};

export default LandingPage;
